import React, {
  useState,
} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

import RoundedButton from 'Components/ComponentLibrary/Components/Uncategorized/RoundedButton';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import MetaField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { useFooterContext } from 'Context/FooterContext';
import Portal from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Portal';
import BaseFormLayout from 'Components/ComponentLibrary/Templates/Unauthenticated/Content/BaseFormLayout';
import { useNewLoginContext } from '../../../NewLoginContext';
import ChangePasswordButtonPicker from './ChangePasswordButtonPicker';
import AgreementsBlurb from './AgreementsBlurb';

const styles = (theme) => ({
  root: {},
  changePasswordButton: {
    margin: theme.spacing(2, 0),
  },
  message: {},
  errorList: {},
});

const LoginLayout = ({
  className,
  classes,
}) => {
  const { handleSubmit } = useNewLoginContext();
  const { footerRef } = useFooterContext();
  const { resource, onSubmit, unsourcedErrors } = useMetaLayoutContext();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const onFormSubmit = async event => {
    setIsSubmitting(true);
    if (event) {
      event.preventDefault();
    }
    const coll = await onSubmit();
    if (coll) {
      handleSubmit(coll);
    }
    setIsSubmitting(false);
  };

  return (
    <BaseFormLayout
      onSubmit={event => onFormSubmit(event)}
      id={'authentication-login-form'}
      className={classNames(classes.root, className)}
      title={'Login to your account'}
      errors={unsourcedErrors}
      message={resource.attr('message')}
    >
      {/* ---- Email Address Input ---- */}
      <MetaField
        attr={'emailAddress'}
        inputProps={{
          test: 'email-field',
        }}
      />

      {/* ---- Password Input ---- */}
      <MetaField
        attr={'password'}
        inputProps={{
          test: 'password-field',
        }}
      />

      {/* ---- Footer / Actions (Portal)---- */}
      <Portal container={footerRef.current}>
        {/* ---- Login Button ---- */}
        <RoundedButton
          disableElevation
          disabled={isSubmitting}
          type={'submit'}
          form={'authentication-login-form'}
          variant={'contained'}
          color={'primary'}
          onClick={onFormSubmit}
          fullWidth
          test={'login-button'}
        >
          {'Login'}
        </RoundedButton>

        {/* ---- Change Password Button ---- */}
        <ChangePasswordButtonPicker className={classes.changePasswordButton} disabled={isSubmitting} />

        {/* ---- Wesite / Privacy Policy Agreements  ---- */}
        <AgreementsBlurb />

      </Portal>
    </BaseFormLayout>
  );
};

LoginLayout.defaultProps = {
  className: '',
};

LoginLayout.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};


export default withStyles(styles)(LoginLayout);
